import React, { Component } from "react";

export class Progress extends Component {  

  jumpToStep = (e, step) => {
    e.preventDefault();
    this.props.jumpToStep(step);
  };

  render() {

    const { values, activeStep } = this.props;

    return (
      <ul className="ob-progress">
        <li className={`ob-progress__step ${values.step1FormValid ? "complete" : ""} ${activeStep === 1 ? "active" : ""}`}>
          <p className="progress-step__title">
            Location <span className="hide-mobile">Details</span>&nbsp;
            {
                (values.step1FormValid && activeStep !== 1) ?
                (
                  <a href="/"
                    className="progress-step__edit"
                    onClick={(e) => this.jumpToStep(e, 1)}>Edit</a>
                ) :
                (null)
            }
          </p>
          <div className="progress-step__columns">
            <div className="progress-step__column progress-step__column--50">
              <p className="progress-step__column-title">Moving from:</p>
              <p className="progress-step__column-value">
                {values.movingFromStreet}
              </p>
              <p className="progress-step__column-value">
                {values.movingFromUnit}
              </p>
            </div>
            <div className="progress-step__column progress-step__column--50">
              <p className="progress-step__column-title">Moving to:</p>
              <p className="progress-step__column-value">
                {values.movingToStreet}
              </p>
              <p className="progress-step__column-value">
                {values.movingToUnit}
              </p>
            </div>
          </div>
        </li>
        <li className={`ob-progress__step ${values.step2FormValid ? "complete" : ""} ${activeStep === 2 ? "active" : ""}`}>
          <p className="progress-step__title">
            Move <span className="hide-mobile">Details</span>&nbsp;
            {
                (values.step2FormValid && activeStep !== 2) ?
                (
                  <a href="/"
                    className="progress-step__edit"
                    onClick={(e) => this.jumpToStep(e, 2)}>Edit</a>
                ) :
                (null)
            }
          </p>
          <div className="progress-step__columns">
            <div className="progress-step__column progress-step__column--33">
              <p className="progress-step__column-title">Date:</p>
              <p className="progress-step__column-value">{values.movingDate.toLocaleDateString()}</p>
            </div>
            <div className="progress-step__column progress-step__column--33">
              <p className="progress-step__column-title">Size:</p>
              <p className="progress-step__column-value">{values.houseSize}</p>
            </div>
            <div className="progress-step__column progress-step__column--33">
              <p className="progress-step__column-title">Vehicle:</p>
              <p className="progress-step__column-value">
                {values.movingVehicle}
              </p>
            </div>
          </div>
        </li>
        <li className={`ob-progress__step ${values.step3FormValid ? "complete" : ""} ${activeStep === 3 ? "active" : ""}`}>
          <p className="progress-step__title">
            Contact <span className="hide-mobile">Detail</span>&nbsp;
            {
                (values.step3FormValid && activeStep !== 3) ?
                (
                  <a href="/"
                    className="progress-step__edit"
                    onClick={(e) => this.jumpToStep(e, 3)}>Edit</a>
                ) :
                (null)
            }
          </p>
          <div className="progress-step__columns">
            <div className="progress-step__column">
              <p className="progress-step__column-title">
                {values.contactName}
              </p>
              <p className="progress-step__column-value">
                {values.contactEmail}
              </p>
              <p className="progress-step__column-value">
                {values.contactPhone}
              </p>
            </div>
          </div>
        </li>
        <li className={`ob-progress__step ${activeStep === 5 ? "active" : ""}`}>
          <p className="progress-step__title">
            <span className="hide-mobile">Instant </span> Quote
          </p>
          <div className="progress-step__columns">
            <div className="progress-step__column">
              <p className="progress-step__column-title">{values.quote}</p>
            </div>
          </div>
        </li>
      </ul>
    );
  }
}

export default Progress;
